const checkedText = {
  deal:"文本处理",
  intelligent:"文本智能",
  picture:"图像智能",
  voice:"语音智能",
  distribution:"智能分发"
}

class applicationContraller {

  constructor($scope, modal, message,applicationAPI,$window){

    "ngInject"
    // this.modal = modal
    this.$scope = $scope;
    this.$window = $window;
    this.modal = modal;
    this.applicationAPI = applicationAPI;
    this.message = message

    this.checkBoxList = [];
    this.lang = this.$window.localStorage.yuanben_lang
    this.checkBox = {
      deal:false,
      intelligent:false,
      picture:false,
      voice:false,
      distribution:false,
    };
    this.isChecked = false
    this.form = {
        // contact_name: "",
        // company_name: "",
        // contact_email: "",
        // contact_phone: "",
        // service_type: "",
        // company_trade: "",
        // service_desc: ""
    }
    let self = this
    this.$scope.$watch("$ctrl.checkBox",function(val){
        if(self.getChecked()){
          self.isChecked = false
        }
    },true)
    // console.log(this.$window.localStorage.yuanben_lang)

  }

    getChecked(){
      let arrs = Object.keys(this.checkBox)
      let str = ""
      arrs.forEach(e=>{
        if(this.checkBox[e]){
          str+=checkedText[e]+","
        }
      })
      return str.slice(0,str.length-1)
    }

  submit(){
    this.$scope.form.$setSubmitted();
    // console.log(this.$scope.form)
    if(!this.$scope.form.$valid){
      return 
    }
    
    if(!this.getChecked()){
      this.isChecked = true
      return 
    }else{
      this.isChecked = false
    }


    let data ={
      contact_name: this.form.contact_name,
      company_name: this.form.company_name,
      contact_email: this.form.contact_email,
      contact_phone: this.form.contact_phone,
      service_type: this.getChecked(),
      company_trade: this.form.company_trade,
      service_desc: this.form.service_desc
    }
    // console.log(data)
    this.applicationAPI.one().post("",data).then(res => {
        if(res.status.code === 200){
          this.modal.open("application-success");
        }
    })
  }
  quit(){
    window.opener = null;//禁止某些浏览器的一些弹窗
    window.open('','_self');
    window.close()
  }


}

export default applicationContraller


// WEBPACK FOOTER //
// ./src/app/components/face/application/application.controller.js